// extracted by mini-css-extract-plugin
export default {"link":"ModuleCard_link__CFlqk","title":"ModuleCard_title__uwwZi","description":"ModuleCard_description__CcmVA","footer":"ModuleCard_footer__PDW2e"};